import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-message-card',
  templateUrl: './message-card.component.html',
  styleUrls: ['./message-card.component.scss']
})
export class MessageCardComponent {
  /**
   * container do card de mensagens exibido nas telas de detalhes
   */
  @Input() function: void;
}
